import {
  UserNotificationsSystemItem,
  UserNotificationsUserItem,
} from '@infotech-soe/merps/types/Notifications';
import { TDatabaseId } from '@infotech-soe/metaschema';

type NotificationsEvents = {
  system: [UserNotificationsSystemItem];
  'system-delete': [TDatabaseId];
};

type PrintEvents = {
  done: [UserNotificationsUserItem];
};

type SchemasEvents = {
  'reports-updated': [never];
  updated: [string];
};

type DatasetEvents = {
  recordUpdated: [string, string, string, string, string?];
};

type ActionEvents = {
  progress: [{ progress: number; message?: string; cancellable?: boolean }];
};

type SupportedEventApi = {
  notifications: 'system' | 'system-delete';
  print: 'done';
  schemas: 'reports-updated' | 'updated';
  dataset: 'recordUpdated';
  actions: 'progress';
};

export type InterfaceName = keyof SupportedEventApi;
export type EventName<T extends InterfaceName> = SupportedEventApi[T];

type SupportedEventArgs = NotificationsEvents &
  PrintEvents &
  SchemasEvents &
  DatasetEvents &
  ActionEvents;

type EventArgs<
  I extends InterfaceName,
  T extends EventName<I>,
> = SupportedEventArgs[T];

export class RemoteEvent<I extends InterfaceName, E extends EventName<I>> {
  constructor(
    public readonly interfaceName: I,
    public readonly eventName: E,
    public readonly eventArgs: EventArgs<I, E>
  ) {}

  public static listenerFor<
    StaticI extends InterfaceName,
    StaticE extends EventName<StaticI>,
  >(
    interfaceName: StaticI,
    eventName: StaticE,
    handler: (...eventArgs: EventArgs<StaticI, StaticE>) => void
  ) {
    return (event: RemoteEvent<StaticI, StaticE>): void => {
      if (
        event.interfaceName === interfaceName &&
        event.eventName === eventName
      ) {
        handler(...event.eventArgs);
      }
    };
  }
}
